class LedgerDelegate {
    setRows(rows) {
        this.setState({ rows });
    }
}

export default LedgerDelegate;
